import type moment from "moment";
import React from "react";
import { TimePicker } from "../components";
import { Checkbox } from "components/Atoms/inputs/Checkbox";

interface Props {
  onStartTimeChanged: (start: moment.Moment) => void
  onEndTimeChanged: (end: moment.Moment) => void
  onNextDayChanged: (nextDay: boolean) => void

  start: moment.Moment
  end: moment.Moment
  nextDay: boolean
  startTimeError: boolean
}

const TimeRange = (props: Props) => <>
  <div className="flex margin-bottom-small">
    <div>
      <TimePicker
        error={props.startTimeError}
        hourNotation={site.culture.is24Hr ? "24hr" : "12hr"}
        step={10}
        value={props.start}
        onChange={props.onStartTimeChanged}
        canBeEmpty
      />
    </div>
    <div className="padding">-</div>
    <div>
      <TimePicker
        hourNotation={site.culture.is24Hr ? "24hr" : "12hr"}
        step={10}
        value={props.end}
        onChange={props.onEndTimeChanged}
        canBeEmpty
      />
    </div>
  </div>
  <Checkbox
    label={RESX.DateTime.NextDay}
    checked={props.nextDay}
    onChange={(_, checked) => { props.onNextDayChanged(checked); }}
  />
</>;

export default TimeRange;